import { render, staticRenderFns } from "./LaboratoryItemInputForm.vue?vue&type=template&id=19c4fd7d&scoped=true&"
import script from "./LaboratoryItemInputForm.vue?vue&type=script&lang=js&"
export * from "./LaboratoryItemInputForm.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryItemInputForm.vue?vue&type=style&index=0&id=19c4fd7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4fd7d",
  null
  
)

export default component.exports